import React  from "react";
import { useParams } from 'react-router-dom';
import JobRoleDetails from "./components/JobRoleDetails";
import Card from "components/card";

const ViewJobRole = () => {

	const { roleId } = useParams();
	console.log(roleId);
    
	return (
	    <div className="mt-3">
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<Card extra={"w-full h-full p-4"}>
					<JobRoleDetails recordId={roleId} />
				</Card>
	      	</div>
	    </div>
    );
};

export default ViewJobRole;